import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, FormControlLabel, MenuItem, Switch, TextField } from '@mui/material';
import s from '../styles/ProductsToolbar.module.scss';

export default function ProductsToolbar({
    brands = [],
    brandId,
    onBrandChange,
    query,
    onQueryChange,
    sort,
    onSortChange,
    dir,
    onDirChange,
    availableOnly = false,
    onAvailableOnlyChange = () => {},
}) {
    return (
        <div className={s.wrap}>
            <div className={s.filtersRow}>
                <TextField
                    size="small"
                    className={s.search}
                    label="Search products"
                    placeholder="Title, flavor, description"
                    value={query}
                    onChange={(e) => onQueryChange(e.target.value)}
                />

                <TextField
                    size="small"
                    select
                    label="Brand"
                    value={brandId}
                    onChange={(e) => onBrandChange(e.target.value)}
                    className={s.select}
                >
                    <MenuItem value="">All brands</MenuItem>
                    {brands.map((b) => (
                        <MenuItem key={b.id} value={b.id}>{b.name}</MenuItem>
                    ))}
                </TextField>

                <TextField
                    size="small"
                    select
                    label="Sort"
                    value={sort}
                    onChange={(e) => onSortChange(e.target.value)}
                    className={s.shortSelect}
                >
                    <MenuItem value="createdAt">Created</MenuItem>
                    <MenuItem value="name">Name</MenuItem>
                    <MenuItem value="weightGrams">Weight</MenuItem>
                    <MenuItem value="isAvailable">Availability</MenuItem>
                </TextField>

                <TextField
                    size="small"
                    select
                    label="Direction"
                    value={dir}
                    onChange={(e) => onDirChange(e.target.value)}
                    className={s.shortSelect}
                >
                    <MenuItem value="desc">Desc</MenuItem>
                    <MenuItem value="asc">Asc</MenuItem>
                </TextField>

                <FormControlLabel
                    control={(
                        <Switch
                            size="small"
                            checked={availableOnly}
                            onChange={(e) => onAvailableOnlyChange(e.target.checked)}
                        />
                    )}
                    label="Available only"
                    sx={{ ml: 0.5 }}
                />
            </div>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1 }}>
                <span className={s.hint}>Product order is managed inside each brand page.</span>
                {brandId && (
                    <Button
                        component={RouterLink}
                        to={`/brands/${encodeURIComponent(String(brandId))}`}
                        size="small"
                        variant="outlined"
                    >
                        Open brand reorder
                    </Button>
                )}
            </Box>
        </div>
    );
}

